import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router'
import { Drawer } from '@/components/ui/drawer'
import { CommandPalette } from './CommandPalette'
import { IdleSessionGuard } from './IdleSessionGuard'
import { Brand, NavList, Sidebar } from './Sidebar'
import { Topbar } from './Topbar'

const COLLAPSE_KEY = 'cp.sidebar.collapsed'

export function AppShell() {
  const { t } = useTranslation()
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(COLLAPSE_KEY) === '1'
    } catch {
      return false
    }
  })
  const [cmdOpen, setCmdOpen] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)
  const toggle = () =>
    setCollapsed((c) => {
      try {
        localStorage.setItem(COLLAPSE_KEY, c ? '0' : '1')
      } catch {
        /* yok say */
      }
      return !c
    })

  return (
    <div className="flex min-h-dvh">
      <IdleSessionGuard />
      <Sidebar collapsed={collapsed} onToggle={toggle} />
      <Drawer open={mobileOpen} onOpenChange={setMobileOpen} title={t('common.menu')} className="lg:hidden">
        <Brand inverted />
        <NavList onNavigate={() => setMobileOpen(false)} />
      </Drawer>
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onSearch={() => setCmdOpen(true)} onMenu={() => setMobileOpen(true)} />
        <main className="flex w-full min-w-0 flex-1 flex-col p-3">
          <div className="flex-1 rounded-2xl border bg-card p-3 shadow-[0_1px_2px_color-mix(in_oklab,var(--shadow-soft)_4%,transparent),0_12px_32px_-12px_color-mix(in_oklab,var(--shadow-color)_18%,transparent)] dark:shadow-[0_12px_32px_-12px_color-mix(in_oklab,var(--black)_60%,transparent)]">
            <Outlet />
          </div>
        </main>
      </div>
      <CommandPalette open={cmdOpen} onOpenChange={setCmdOpen} />
    </div>
  )
}
